import styles from './ModalRadialProgression.module.css'
import { RadialProgress } from '@/components/RadialProgress'

export interface ModalRadialProgressionProps {
  progress: number
  completed: number
  total: number
  withError: boolean
}

export function ModalRadialProgression({
  progress,
  completed,
  total,
  withError,
}: ModalRadialProgressionProps) {
  return (
    <div className={styles.root}>
      <RadialProgress
        size={150}
        thickness={4}
        progress={progress}
        stroke={withError ? 'var(--red500)' : 'var(--theme-darken)'}
      >
        <div className={styles.info}>
          <div className={styles.percentage}>{progress}%</div>
          <div className={styles.completionCount}>
            <span>{completed}</span> / <span>{total}</span>
          </div>
        </div>
      </RadialProgress>
    </div>
  )
}
